/** OpenLayers grid-system factory for NordDeGuerre; the theatre data itself is ol-free in `NordDeGuerre.ts`. */
import { registerCRS } from '@zwaarcontrast/ol-graticule-projected';
import { NORD_DE_GUERRE_SCHEME } from '../formatters/schemes.js';
import { assembleMBSGridSystem } from './shared.js';
import { NORD_DE_GUERRE_CLIP_POLYGON, NORD_DE_GUERRE_CRS, NORD_DE_GUERRE_DEFAULT_TOWGS84, NORD_DE_GUERRE_EXTENT, buildNordDeGuerreProj4, } from './NordDeGuerre.js';
/** Build a Nord de Guerre grid with the MBS letter-cell formatter and standard coverage polygon. */
export function createNordDeGuerreGridSystem(options) {
    const { clipPolygon: clipOverride, towgs84, ...projOptions } = options ?? {};
    const towgs84Effective = towgs84 === undefined ? NORD_DE_GUERRE_DEFAULT_TOWGS84 : towgs84;
    if (towgs84Effective !== null &&
        towgs84Effective.length !== 3 &&
        towgs84Effective.length !== 7) {
        throw new Error(`towgs84 must have 3 or 7 elements, got ${towgs84Effective.length}`);
    }
    registerCRS(NORD_DE_GUERRE_CRS, buildNordDeGuerreProj4(towgs84Effective));
    return assembleMBSGridSystem(NORD_DE_GUERRE_CRS, NORD_DE_GUERRE_SCHEME, clipOverride ?? NORD_DE_GUERRE_CLIP_POLYGON, projOptions, NORD_DE_GUERRE_EXTENT);
}
//# sourceMappingURL=NordDeGuerre.grid.js.map